export default "/images/vendor/flag-icon-css/flags/4x3/rs.svg?51e6180ced2cf59fd51e42fcc904988b";